import { i18n } from '@zet/localization'

export const STEP_CONST = {
  APPLICATION_FORM: 'APPLICATION_FORM',
  EKYC: 'EKYC',
  APPLICATION_TRACKING: 'APPLICATION_TRACKING',
  LEAD_FULFILLED: 'LEAD_FULFILLED',
}

export const STEP_MAP = {
  [STEP_CONST.APPLICATION_FORM]: 1,
  [STEP_CONST.EKYC]: 2,
  [STEP_CONST.APPLICATION_TRACKING]: 3,
  [STEP_CONST.LEAD_FULFILLED]: 4,
}

export const STEP_DATA = [
  {
    step: STEP_MAP.APPLICATION_FORM,
    h1: i18n.t('demoSale.step1.h1'),
    sh1: i18n.t('demoSale.step1.sh1'),
    cta: i18n.t('demoSale.step1.cta'),
    navigateTo: 'EnterNumberAndPan',
  },
  {
    step: STEP_MAP.EKYC,
    h1: i18n.t('demoSale.step2.h1'),
    sh1: i18n.t('demoSale.step2.sh1'),
    cta: i18n.t('demoSale.step2.cta'),
    navigateTo: 'Vkyc',
  },
  {
    step: STEP_MAP.APPLICATION_TRACKING,
    h1: i18n.t('demoSale.step3.h1'),
    sh1: i18n.t('demoSale.step3.sh1'),
    cta: i18n.t('demoSale.step3.cta'),
    navigateTo: 'tracking',
  },
]
